import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const data = {
  heading: `In this comprehensive G2 Grid® report on the CDP market, you’ll get:`,
  list: [
    `Detailed profiles and customer ratings of the top CDPs on G2`,
    `Stack rankings of CDP vendors based on validated reviews from customers`,
    `Customer scores based on ease of use, likelihood to recommend, support, and more`,
  ],
}

const ComprehensiveG2: FC = () => {
  return (
    <StyledSectionBase variant="noCopy">
      <StyledSectionContents>
        <CopyTextBase>
          <StyledCopyTextHeading tag="h2" variant="h2">
            {data.heading}
          </StyledCopyTextHeading>
          <Ul>
            {data.list.map((item, index) => (
              <StyledListItem key={index}>{item}</StyledListItem>
            ))}
          </Ul>
        </CopyTextBase>
      </StyledSectionContents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 24px;

    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      padding-top: 40px;
    }
  }
`

const StyledCopyTextHeading = styled(CopyText.Heading)`
  margin-bottom: 32px;
`

const Ul = styled.ul`
  padding-left: 33px;
  display: grid;
`

const StyledListItem = styled.li`
  font-weight: 400;
  ${({ theme }) => theme.typography.pMedium};
  font-size: 20px;
`

const StyledSectionContents = styled(Section.Contents)`
  max-width: 844px;
  margin: 0 auto;
`

export default ComprehensiveG2
